/**
 * Utility function to scroll to top of page
 * Can be called manually when needed
 */
export const scrollToTop = (smooth = false) => {
  const scrollOptions = {
    top: 0,
    left: 0,
    behavior: smooth ? 'smooth' : 'auto'
  };

  // Primary method
  window.scrollTo(scrollOptions);
  
  // Fallback methods for better browser compatibility
  if (document.documentElement) {
    document.documentElement.scrollTop = 0;
  }
  if (document.body) {
    document.body.scrollTop = 0;
  }
  
  // Handle any custom scroll containers
  const scrollableElements = document.querySelectorAll('[data-scroll-container]');
  scrollableElements.forEach(element => {
    element.scrollTop = 0;
  });
};

/**
 * Scroll to main content area, accounting for header height
 * Useful for pages where you want to skip the header
 */
export const scrollToContent = (offset = 20) => {
  // Try to find the main content area
  const contentSelectors = [
    '.tj-booking-frm', // Specific booking form class
    '.booking-content',
    '.booking-form', 
    '.cab-booking',
    'main',
    '.main-content',
    '.container'
  ];
  
  let contentElement = null;
  for (const selector of contentSelectors) {
    contentElement = document.querySelector(selector);
    if (contentElement) break;
  }
  
  if (contentElement) {
    // Get header height to offset scroll position
    const headerSelectors = ['header', '.header', 'nav', '.navbar', '.top-header'];
    let header = null;
    for (const selector of headerSelectors) {
      header = document.querySelector(selector);
      if (header) break;
    }
    
    const headerHeight = header ? header.offsetHeight : 80; // Default 80px if no header found
    const elementTop = contentElement.offsetTop;
    const scrollPosition = Math.max(0, elementTop - headerHeight - offset);
    
    window.scrollTo({
      top: scrollPosition,
      left: 0,
      behavior: 'smooth'
    });
  } else {
    // Fallback: scroll to a reasonable position below header
    window.scrollTo({
      top: 100, // Scroll to 100px from top to skip header
      left: 0,
      behavior: 'smooth'
    });
  }
};

/**
 * Force scroll to top with multiple attempts
 * Useful for pages with dynamic content loading
 */
export const forceScrollToTop = () => {
  scrollToTop();
  
  // Additional attempts with delays to handle async content
  setTimeout(() => scrollToTop(), 50);
  setTimeout(() => scrollToTop(), 100);
  setTimeout(() => scrollToTop(), 200);
};

/**
 * Force scroll to content with multiple attempts
 * Useful for booking pages with dynamic content loading
 */
export const forceScrollToContent = (offset = 20) => {
  scrollToContent(offset);
  
  // Additional attempts with delays to handle async content
  setTimeout(() => scrollToContent(offset), 100);
  setTimeout(() => scrollToContent(offset), 300);
};

export default scrollToTop;